export default __webpack_public_path__ + "static/media/classification-color.48aa4c1b.svg";